import React from "react";
import LoyaltyPackageList from "features/LoyaltyPackage/presentation/pages/Overview";

function LoyaltyPackageListPage() {
  return <LoyaltyPackageList />;
}

export default LoyaltyPackageListPage;
